export default {
  getAllRecentListingsWithoutActiveShowing(state) {
    return state.allRecentListingsWithoutActiveShowing;
  },
  getListingsWithActiveShowing(state) {
    return state.allListingsWithActiveShowing;
  },
}
